export const MALL_LIST_REQUEST = "MALL_LIST_REQUEST";
export const MALL_LIST_SUCCESS = "MALL_LIST_SUCCESS";
export const MALL_LIST_FAIL = "MALL_LIST_FAIL";
export const MALL_LIST_RESET = "MALL_LIST_RESET";

export const MALL_EDIT_REQUEST = "MALL_EDIT_REQUEST";
export const MALL_EDIT_SUCCESS = "MALL_EDIT_SUCCESS";
export const MALL_EDIT_FAIL = "MALL_EDIT_FAIL";
export const MALL_EDIT_RESET = "MALL_EDIT_RESET";

export const MALL_DELETE_REQUEST = "MALL_DELETE_REQUEST";
export const MALL_DELETE_SUCCESS = "MALL_DELETE_SUCCESS";
export const MALL_DELETE_FAIL = "MALL_DELETE_FAIL";
export const MALL_DELETE_RESET = "MALL_CREATE_RESET";

export const MALL_CREATE_REQUEST = "MALL_CREATE_REQUEST";
export const MALL_CREATE_SUCCESS = "MALL_CREATE_SUCCESS";
export const MALL_CREATE_FAIL = "MALL_CREATE_FAIL";
export const MALL_CREATE_RESET = "MALL_CREATE_RESET";

export const MALL_UPDATE_REQUEST = "MALL_UPDATE_REQUEST";
export const MALL_UPDATE_SUCCESS = "MALL_UPDATE_SUCCESS";
export const MALL_UPDATE_FAIL = "MALL_UPDATE_FAIL";
export const MALL_UPDATE_RESET = "MALL_UPDATE_RESET";
